document.addEventListener("DOMContentLoaded", () => {
  initFooterSlider(document);
});

document.addEventListener("shopify:section:load", (evt) => {
  initFooterSlider(evt.target);
});

function initFooterSlider(root) {
  const slider = root.querySelector("[data-slider]");
  if (!slider) return;

  if (slider.dataset.initialized === "true") return;
  slider.dataset.initialized = "true";

  const track = slider.querySelector("[data-track]");
  const dotsContainer = slider.querySelector("[data-dots]");

  let originalSlides = Array.from(track.children);
  const originalCount = originalSlides.length;

  track.innerHTML = "";
  dotsContainer.innerHTML = "";

  originalSlides.forEach((s) => track.appendChild(s));
  originalSlides.forEach((s) => track.appendChild(s.cloneNode(true)));
  originalSlides.forEach((s) => track.appendChild(s.cloneNode(true)));

  const allSlides = Array.from(track.children);

  let index = originalCount;
  let slideWidth = 0;
  let animating = false;
  let autoplay;

  function updateWidths() {
    slideWidth = slider.offsetWidth;
    allSlides.forEach((s) => (s.style.minWidth = slideWidth + "px"));

    track.style.transition = "none";
    track.style.transform = `translateX(-${index * slideWidth}px)`;
  }

  updateWidths();
  window.addEventListener("resize", updateWidths);

  /* --------------------------
      DOTS ERZEUGEN
  --------------------------- */
  for (let i = 0; i < originalCount; i++) {
    const dot = document.createElement("span");
    dot.dataset.index = i;
    if (i === 0) dot.classList.add("active");
    dotsContainer.appendChild(dot);
  }

  const dots = dotsContainer.querySelectorAll("span");

  function updateDots() {
    const n = index % originalCount;
    dots.forEach((d, i) => d.classList.toggle("active", i === n));
  }

  /* --------------------------
      AUTOPLAY SCHRITT
  --------------------------- */

  function next() {
    if (animating) return;
    animating = true;

    index++;
    track.style.transition = "transform 0.45s linear";
    track.style.transform = `translateX(-${index * slideWidth}px)`;

    // 👉 DOTS SOFORT updaten (SYNC!)
    updateDots();

    setTimeout(() => {
      animating = false;

      if (index >= originalCount * 2) {
        track.style.transition = "none";
        index = originalCount;
        track.style.transform = `translateX(-${index * slideWidth}px)`;
        updateDots();
      }
    }, 460);
  }

  autoplay = setInterval(next, 4500);

  /* --------------------------
      DOT CLICK (SOFORT)
  --------------------------- */

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      if (animating) return;

      clearInterval(autoplay);

      const target = parseInt(dot.dataset.index);

      // Sofort DOT setzen
      dots.forEach((d) => d.classList.remove("active"));
      dot.classList.add("active");

      // Direkt zum Ziel springen (ohne Animation)
      index = originalCount + target;
      track.style.transition = "none";
      track.style.transform = `translateX(-${index * slideWidth}px)`;

      // Animation wieder aktivieren
      setTimeout(() => {
        track.style.transition = "transform 0.45s linear";
      }, 20);

      autoplay = setInterval(next, 4500);
    });
  });

  /* --------------------------
      TOUCH / SWIPE
  --------------------------- */

  let startX = 0;
  let isTouching = false;

  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isTouching = true;
    clearInterval(autoplay);
    track.style.transition = "none";
  });

  track.addEventListener("touchmove", (e) => {
    if (!isTouching) return;
    const dx = e.touches[0].clientX - startX;
    track.style.transform = `translateX(${-index * slideWidth + dx}px)`;
  });

  track.addEventListener("touchend", (e) => {
    if (!isTouching) return;
    isTouching = false;

    const dx = e.changedTouches[0].clientX - startX;

    if (dx > 40) index--;
    else if (dx < -40) index++;

    track.style.transition = "transform 0.45s ease";
    track.style.transform = `translateX(-${index * slideWidth}px)`;

    // DOT sofort updaten
    updateDots();

    setTimeout(() => {
      if (index <= originalCount - 1) {
        track.style.transition = "none";
        index = originalCount + (index % originalCount);
        track.style.transform = `translateX(-${index * slideWidth}px)`;
        updateDots();
      }

      if (index >= originalCount * 2) {
        track.style.transition = "none";
        index = originalCount;
        track.style.transform = `translateX(-${index * slideWidth}px)`;
        updateDots();
      }

      autoplay = setInterval(next, 4500);
    }, 460);
  });
}
